import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Company } from '../intefaces/company.interface';
import { HttpHeaders } from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CompanyService {
    private readonly headers: HttpHeaders;

    constructor(private http: HttpClient) {
    this.headers = new HttpHeaders().set('Authorization', 'Bearer Gustav');
  }
    /**
     * Retrieves an Infringement by sending a GET request with a request body.
     * Note: GET requests typically don't include a body. If your API does not support
     * a GET with a body, consider changing this to a POST request.
     *
     * @returns An Observable of Infringement.
     */
    getCompanyList(): any {
      // The request body to send with the GET request.
      const params = new HttpParams().set('resource', 'company')
      const headers = this.headers


      return this.http.get(environment.apiUrl, { headers, params });
    }
}
